import { gPaths } from 'views/AppLocals/configs'
import createSettingContent from 'views/AppLocals/factory/createSettingContent'
import CourseContext from '../CourseContext'

const CourseSettingsContent = ({ Wrapper, routes }) => {
  const rootPath = gPaths.courseSettings
  return createSettingContent(CourseContext, {
    routes,
    Wrapper,
    rootPath,
  })
}

export default CourseSettingsContent
